import { CloudPremisePlugin } from "@cloudpremise/portal_core";
import { routes, menus, userMenus, footerMenus, settingMenus } from "./src";
import packageJson from "./package.json";

class Firebase extends CloudPremisePlugin {};

const FirebasePlugin = new Firebase ({
    name: packageJson.name,
    description: packageJson.description,
    status: packageJson.status,
    routes: routes,
    menus: menus,
    userMenus: userMenus,
    footerMenus: footerMenus,
    settingMenus: settingMenus,
    render: () => {
        return null
    }
});

export default FirebasePlugin;